import { forwardRef, useImperativeHandle, useRef } from 'react'
import { SIDRender, SLowcodeList } from 'shj-components'
import config from './config'
import { Tag } from 'antd'
import { TabComponentInterface } from '../../../index.d'
import { useParams, useNavigate } from 'react-router-dom'
import { getResponseListForCustomer } from '@/services/goods'
import { apiData2Table } from '@/utils/data'

const Collection = forwardRef<TabComponentInterface>((_, ref) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef = useRef<any>()

  const colors = {
    整家: 'magenta',
    整装: 'purple',
    软装: 'blue',
    零售: 'cyan',
    定制: 'cyan',
    局改: 'red',
  }

  const orderStatusColors = {
    待签约: 'volcano',
    待支付: 'purple',
    已生效: 'cyan',
    已失效: 'default',
    已退单: 'red',
    服务中: 'blue',
    已完成: 'green',
  }

  // 暴露列表项隐藏弹窗的打开方法
  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  // 获取收款列表
  const fetchList = () => {
    return new Promise((resolve, reject) => {
      try {
        getResponseListForCustomer({ customerId: id }).then((res: any) => {
          resolve(apiData2Table({ list: res }))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  const extension = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      // 订单ID渲染
      orderIdRender(_, record: Record<string, any>) {
        return (
          <SIDRender
            id={record.orderNo}
            onClick={() =>
              navigate(`/fms/paymentService/${record.id}/${record.orderId}/${record.dealMode}`)
            }
          />
        )
      },
      // 需求标签渲染
      demandTagRender(text: any) {
        return <Tag color={colors[text]}>{text}</Tag>
      },
      // 订单状态渲染
      orderStatusRender(text: any) {
        return text ? <Tag color={orderStatusColors[text]}>{text}</Tag> : '-'
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
})

export default Collection
